module.exports = __webpack_public_path__ + "img/write-off.6d6bc694.svg";